export default "__VITE_ASSET__DurJGLbp__"